import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getConfiguredLabel } from "../../../../common/commonHelper";
import { DataTypes, TemplateTypes } from "../../../../common/constants";
import {
  addButton,
  addUserButton,
  addUserTitle,
  addUserTitleMessage,
  addUserToasterHeader,
  adminPage,
  adminTabName,
  cancelButton,
  deleteButton,
  deleteMessage,
  deleteUserTitle,
  deleteUserTitleMessage,
  DocumentsPage,
  editUserTitle,
  editUserTitleMessage,
  editUserToasterHeader,
  passwordReset,
  saveButton,
  userTabName
} from "../../../../common/labelConstants";
import {
  setButtonsData,
  setButtonsText,
} from "../../../../store/banner/bannerSlice";
import { BulkUserUpload } from "../../../bulkUsersUpload/bulkUpload";
import SlbButton from "../../../controls/button";
import DataListing from "../../../listing/listing";
import { PasswordResetPopup } from "./passwordReset";

export const Users = (props) => {
  const editTemplate = "editUsers";
  const [userToBeReset, setUserToBeReset] = useState();
  const dispatch = useDispatch();
  const handleRowClassName = (rowData) => {
    const rowClassName = rowData?.active?.hasOwnProperty("No");
    if (rowClassName) {
      return "admin_rowStyle";
    }
  };
  const [showResetPopup, setShowResetPopup] = useState(false);

  const handlePasswordReset = (record) => {
    setUserToBeReset(record);
    setShowResetPopup(true);
  };

  const addUser = () => {
    dispatch(setButtonsData(true));
  };
  const addButtonText = getConfiguredLabel(adminPage, addUserButton);
  const bannerContent = {
    tabName: getConfiguredLabel(adminPage, adminTabName),
    actionsJSX: (
      <>
        <div className="cancel-save-btns">
          <BulkUserUpload />
          <SlbButton className=" " onClick={addUser}>
            {addButtonText}
          </SlbButton>
        </div>
      </>
    ),
  };

  useEffect(() => {
    dispatch(setButtonsText(bannerContent));
    return () => {
      dispatch(setButtonsText(""));
    };
  }, []);

  const actionToaster = {
    add: {
      title: getConfiguredLabel(adminPage, addUserToasterHeader),
      message: getConfiguredLabel(adminPage, addUserTitleMessage),
    },
    edit: {
      title: getConfiguredLabel(adminPage, editUserToasterHeader),
      message: getConfiguredLabel(adminPage, editUserTitleMessage),
    },
    delete: {
      title: getConfiguredLabel(adminPage, deleteUserTitle),
      message: getConfiguredLabel(adminPage, deleteUserTitleMessage),
    },
  };

  return (
    <div>
      <DataListing
        paginator={true}
        dataType_id={DataTypes.Users.id}
        templateName={"users"}
        rowClass={handleRowClassName}
        actionToaster={actionToaster}
        handlePasswordReset={handlePasswordReset}
        pageActionsInfo={{
          add: {
            title: getConfiguredLabel(adminPage, addUserTitle),
            message: "",
            actions: {
              ok: { label: getConfiguredLabel(DocumentsPage, addButton) },
              cancel: {
                label: getConfiguredLabel(DocumentsPage, cancelButton),
              },
            },
          },
          edit: {
            title: getConfiguredLabel(adminPage, editUserTitle),
            message: "",
            actions: {
              ok: { label: getConfiguredLabel(DocumentsPage, saveButton) },
              cancel: {
                label: getConfiguredLabel(DocumentsPage, cancelButton),
              },
            },
          },
          delete: {
            title: getConfiguredLabel(adminPage, deleteUserTitle),
            message: getConfiguredLabel(DocumentsPage, deleteMessage),
            actions: {
              ok: { label: getConfiguredLabel(DocumentsPage, deleteButton) },
              cancel: {
                label: getConfiguredLabel(DocumentsPage, cancelButton),
              },
            },
          },
        }}
        testActionAgainstData={{
          passwordReset: (row) => {
            if ((row?.authType?.val || "").toLowerCase() === "form")
              return true;
            return false;
          },
        }}
        // editDataTemplateName={editTemplate}
        // listDataTemplateName={TemplateTypes.userslisting_table}
        renderHeaderAreaLeft={({ pagingInfo }) => {
          return <>{pagingInfo}</>;
        }}
        renderHeaderAreaRight={({
          btn_delete,
          filter_global,
          orderBy_icon,
          sortBy_dropdown,
          add_item,
          selectedRows,
        }) => {
          return (
            <>
              {filter_global}
              {btn_delete}
              {sortBy_dropdown}
              {/* {add_item(<SlbButton>Add User</SlbButton>)} */}
            </>
            
          );
        }}
      />
      
      {showResetPopup && (
        <PasswordResetPopup
          user={userToBeReset}
          title="Reset Password"
          show={showResetPopup}
          setShowPopup={setShowResetPopup}
        />
      )}
    </div>
  );
};
